import { ellipsisLayout, theyFit } from './ellipsisLayout';
import {
  SegmentIcon,
  BreadcrumbsLayout,
  InternalBreadcrumbsProps,
  Segment,
} from './types';
import { mesureSegment } from './DOMHelpers';
import { HighlightedTextConfig } from '../HighlightedText';

const makeSegment = (
  highlightedText: HighlightedTextConfig,
  icon: SegmentIcon
): Segment => ({
  ...highlightedText,
  icon,
  gap: icon.rightMargin,
});

const toHighlightedTextConfig = (
  breadcrumb: string | HighlightedTextConfig
): HighlightedTextConfig => {
  if (typeof breadcrumb === 'string') {
    return { text: breadcrumb };
  }
  return breadcrumb;
};

export const breadcrumbsLayout = (
  props: InternalBreadcrumbsProps,
  availableWidth: number
): BreadcrumbsLayout => {
  const { breadcrumbs, ellipsis, leadingIcon, dividerIcon, textStyles } = props;

  const segments = breadcrumbs
    .map(toHighlightedTextConfig)
    .map((highlightedText, index) =>
      makeSegment(highlightedText, index === 0 ? leadingIcon : dividerIcon)
    );
  const segmentsWithSizes = segments.map(segment =>
    mesureSegment(segment, textStyles)
  );

  if (theyFit(segmentsWithSizes, availableWidth)) {
    return { breadcrumbs: segments };
  }

  if (segments.length <= 2) {
    return { breadcrumbs: segments, popoverContent: segments };
  }

  const ellipsisWithSizes = mesureSegment(
    makeSegment(toHighlightedTextConfig(ellipsis), dividerIcon),
    textStyles
  );
  const segmentsWithEllipsis = ellipsisLayout(
    segmentsWithSizes,
    availableWidth,
    ellipsisWithSizes
  );
  return {
    breadcrumbs: segmentsWithEllipsis,
    popoverContent: segments,
  };
};
